/**
 * Libellés des cases à cocher « conditions » du parcours signature multi-compteurs.
 * Utilisés par SourceConsentSignConditions (type `both`) et pour référence métier.
 */

const MULTI_CONSENT_CONDITION_TITLES_PDL: string[] = [
    "L'historique des consommations, en kWh, les puissances atteintes et les dépassements de puissance.",
    "L'historique des relevés d'index quotidiens, en kWh, et la puissance maximale quotidienne, en kVA ou kW.",
    "L'historique de courbe de charge jusqu'au pas restitué par le distributeur (et l'activation de la collecte de la courbe de charge si celle-ci n'est pas activée).",
    "Les données techniques et contractuelles disponibles.",
]

const MULTI_CONSENT_CONDITION_TITLES_PCE: string[] = [
    "Les données publiées (données transmises à mon fournisseur d'énergie pour la facturation).",
    "Les données informatives journalières (si disponible).",
    "Les données contractuelles (données relatives au contrat avec mon fournisseur).",
    "Les données techniques (données relatives aux détails techniques de mon compteur).",
]

/**
 * Titres par type de consentement (pdl seul, pce seul, ou mixte ENEDIS / GRDF).
 */
export const MULTI_CONSENT_CONDITION_TITLES_BY_TYPE: Record<
    "pdl" | "pce" | "both",
    string[]
> = {
    pdl: MULTI_CONSENT_CONDITION_TITLES_PDL,
    pce: MULTI_CONSENT_CONDITION_TITLES_PCE,
    both: [
        ...MULTI_CONSENT_CONDITION_TITLES_PDL.map((t) => t + " (ENEDIS)"),
        ...MULTI_CONSENT_CONDITION_TITLES_PCE.map((t) => t + " (GRDF)"),
    ],
}
